import { RootState } from 'rootReducer';

export const VerifyCodeSelector = (state: RootState) => state.commonReducer.verifyPhoneReducer;
